<template>
  <div @click="goLive">
    <p class="time">
      {{ ifToday }} {{ advanceData.liveStartTime | transMonth }}
    </p>
    <div class="box">
      <div class="doc_info">
        <img class="photo" :src="advanceData.headPhoto" alt="" />
        <div class="right">
          <p>
            <span>{{ advanceData.nickName }}</span>
            <span>{{ advanceData.duties }}</span>
          </p>
          <p>{{ advanceData.companyName }}</p>
        </div>
        <img
          class="live"
          v-if="ifNow == 1"
          src="http://cdn.yxvzb.com/newWechat/image/liveIcon_03.png"
        />
        <div class="live fontLive" v-else-if="ifNow == 2">已报名</div>
        <div
          class="live fontLive fontLiveActive"
          v-else-if="ifNow == 3"
          @click.once.stop="signUp"
        >
          报名
        </div>
      </div>
      <h5 class="centent">{{ advanceData.courseName }}</h5>
    </div>
  </div>
</template>
<script>
import { live } from '@/api/ajax';
export default {
  name: '',
  data() {
    return {
      ifToday: '',
      weekList: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      ifNow: '' //1.直播中 2.已报名 3.未报名
    };
  },
  props: {
    advanceData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    goLive() {
      this.$router.push({
        name: 'liveDetail',
        params: { id: this.advanceData.id }
      });
    },
    signUp() {
      live.sign(this.advanceData.id).then(res => {
        if (res.data.status == 'success') {
          this.ifNow = 2;
          this.$vux.toast.show({
            type: 'text',
            position: 'top',
            text: '报名成功'
          });
        }
      });
    }
  },
  computed: {},
  components: {},
  watch: {
    advanceData(val) {
      // console.log('bbb')
      let nowYear = new Date().getFullYear(),
        year = new Date(this.advanceData.liveStartTime).getFullYear(),
        nowMonth = new Date().getMonth(),
        month = new Date(this.advanceData.liveStartTime).getMonth(),
        nowDay = new Date().getDate(),
        day = new Date(this.advanceData.liveStartTime).getDate(),
        timeStamp = new Date(year, month, day).getTime();
      // console.log(timeStamp)
      if (timeStamp == new Date().getTime()) {
        this.ifToday = '今天';
      } else if (
        timeStamp - new Date().getTime() < 1000 * 60 * 60 * 24 &&
        timeStamp - new Date().getTime() > 0
      ) {
        this.ifToday = '明天';
      } else {
        let index = new Date(this.advanceData.liveStartTime).getDay();
        this.ifToday = this.weekList[index];
      }

      if (timeStamp < new Date().getTime()) {
        this.ifNow = 1;
      } else {
        if (this.advanceData.hasSignUp == 0) {
          this.ifNow = 3;
        } else if (this.advanceData.hasSignUp == 1) {
          this.ifNow = 2;
        }
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.time {
  font-size: 0.3733rem;
  color: #027cfa;
}
.box {
  width: 8rem;
  box-shadow: 0 0 0.266rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-top: 0.18rem;
  padding: 0.4rem 0.2666rem;
  .doc_info {
    position: relative;
    display: flex;
    .photo {
      width: 0.9066rem;
      height: 0.9066rem;
      display: block;
      border-radius: 50%;
      border: 1px solid #027cfa;
      margin-right: 0.24rem;
    }
    .live {
      width: 0.96rem;
      height: 0.4rem;
      position: absolute;
      right: 0;
      top: 0;
    }
    .fontLive {
      width: 1.44rem;
      height: 0.587rem;
      line-height: 0.587rem;
      text-align: center;
      font-size: 0.32rem;
      color: #fff;
      background: #d8d8d8;
      border-radius: 0.08rem;
    }
    .fontLiveActive {
      background-image: linear-gradient(-90deg, #2eacfd 0%, #027cfa 100%);
    }
    .right {
      width: 4.48rem;
    }
  }
  .centent {
    margin-top: 0.2666rem;
    font-size: 0.3733rem;
    line-height: 1.3;
  }
  .sign {
    border-radius: 0.08rem;
    width: 1.44rem;
    height: 0.5866rem;
    position: absolute;
    right: 0;
    text-align: center;
    line-height: 0.5866rem;
  }
  .isSign {
    background-image: linear-gradient(-90deg, #027cfa 0%, #2eacfd 100%);
    color: #fff;
  }
}
</style>
